<template>
  <div>
    <b-row class="mb-1">
      <b-col v-if="$can('AssignUnAssign', 'MerchantFOP')" md="6">
        <b-button variant="primary" @click="assignMerchant()">
          <feather-icon icon="PlusIcon" class="mr-25" />
          <span>Assign/UnAssign fop</span>
        </b-button>
      </b-col>
    </b-row>
    <b-card title="Payment Options">
      <b-row>
        <b-col md="3">
          <div>
            <b-form-select
              v-model="selectedStatus"
              :options="statusOptions"
              @change="filterPaymentOptions"
            />
          </div>
        </b-col>
        <b-col md="3">
          <b-form-group>
            <b-form-input
              v-model="filter"
              placeholder="Search"
              type="text"
              class="d-inline-block mr-1"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-table
            striped
            :items="paymentOptions"
            :fields="fields"
            :filter="filter"
            :per-page="perPage"
            :current-page="currentPage"
            caption-top
            :responsive="true"
          >
            <template v-slot:cell(logo)="data">
              <b-avatar :src="data.item.imageUrl" />
            </template>
            <template v-slot:cell(statusDescription)="data">
              <b-badge
                v-if="data.item.statusDescription === `Active`"
                pill
                variant="success"
              >
                Active
              </b-badge>
              <b-badge
                v-else-if="data.item.statusDescription === `InActive`"
                pill
                variant="danger"
              >
                InActive
              </b-badge>
            </template>
            <template v-slot:cell(refundActiveStatusDescription)="data">
              <b-badge
                v-if="data.item.refundActiveStatusDescription === `Active`"
                pill
                variant="success"
              >
                Active
              </b-badge>
              <b-badge
                v-else-if="
                  data.item.refundActiveStatusDescription === `InActive`
                "
                pill
                variant="danger"
              >
                InActive
              </b-badge>
            </template>
            <template v-slot:cell(instruction)="data">
              <b-link
                v-if="
                  (data.item.status === 2 || data.item.status === 1) &&
                  $can('ManageInstructions', 'MerchantFOP')
                "
                :to="{
                  name: 'instructions-manage',
                  params: { id: data.item.id, name: data.item.name },
                }"
              >
                <feather-icon icon="BookOpenIcon" />
                <span class="align-middle ml-50">Manage</span>
              </b-link>
            </template>
            <template
              v-slot:cell(actions)="data"
              v-if="
                $can('EnableDisable', 'MerchantFOP') ||
                $can('ChangeExpiry', 'MerchantFOP') ||
                $can('AssignUnAssign', 'MerchantFOP')
              "
            >
              <b-row>
                <b-dropdown
                  variant="link"
                  no-caret
                  :right="$store.state.appConfig.isRTL"
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="align-middle text-body"
                    />
                  </template>
                  <b-dropdown-item
                    v-if="
                      data.item.status === 1 &&
                      $can('EnableDisable', 'MerchantFOP')
                    "
                    v-b-modal.modal-edit-paymentoption
                    href="#"
                    variant="success"
                    @click="EnablePaymentOption(data.item.id, data.item.name)"
                  >
                    <feather-icon class="yellow-icon" icon="EditIcon" />
                    <span class="align-middle ml-50">Enable for Payment</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-else-if="
                      data.item.status === 2 &&
                      $can('EnableDisable', 'MerchantFOP')
                    "
                    href="#"
                    variant="danger"
                    @click="DisablePaymentOption(data.item.id, data.item.name)"
                  >
                    <feather-icon class="blue-icon" icon="Trash2Icon" />
                    <span class="align-middle ml-50">Disable for Payment</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      data.item.refundActiveStatus === 1 &&
                      $can('EnableDisable', 'MerchantFOP')
                    "
                    v-b-modal.modal-edit-paymentoption
                    href="#"
                    variant="success"
                    @click="
                      EnableRefundPaymentOption(data.item.id, data.item.name)
                    "
                  >
                    <feather-icon class="yellow-icon" icon="EditIcon" />
                    <span class="align-middle ml-50">Enable for Refund</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-else-if="
                      data.item.refundActiveStatus === 2 &&
                      $can('EnableDisable', 'MerchantFOP')
                    "
                    href="#"
                    variant="danger"
                    @click="
                      DisableRefundPaymentOption(data.item.id, data.item.name)
                    "
                  >
                    <feather-icon class="blue-icon" icon="Trash2Icon" />
                    <span class="align-middle ml-50">Disable for Refund</span>
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-if="$can('ChangeExpiry', 'MerchantFOP')"
                    href="#"
                    variant="primary"
                    @click="
                      ChangePaymentOptionExpiry(
                        data.item.id,
                        data.item.name,
                        data.item.expiryHour,
                      )
                    "
                  >
                    <feather-icon class="blue-icon" icon="CalendarIcon" />
                    <span class="align-middle ml-50">Change Expiry</span>
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-if="$can('AssignUnAssign', 'MerchantFOP')"
                    href="#"
                    variant="warning"
                    @click="UnAssignPaymentOption(data.item.id, data.item.name)"
                  >
                    <feather-icon class="blue-icon" icon="TrashIcon" />
                    <span class="align-middle ml-50">UnAssign</span>
                  </b-dropdown-item>
                </b-dropdown>
              </b-row>
            </template>
          </b-table>
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> Showing 1 to &nbsp; </span>
              <b-form-select
                id="per-page-select"
                v-model="perPage"
                :options="[5, 10, 15, 20, { value: 100, text: 'Show all' }]"
                size="sm"
              ></b-form-select>
              <span class="text-nowrap">
                &nbsp; of {{ paymentOptions.length }} entries
              </span>
            </div>
            <div>
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
              />
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <!-- <b-col>
          <div class="mt-3">
            Submitted Names:
            <div>
              --
              Name:{{ name }}
              code:{{ code }}
              country:{{ country }}
              provider:{{ provider }}
              type:{{ type }}
              instruction:{{ instruction }}
            </div>
          </div>
        </b-col> -->
        <b-modal
          id="modal-change-expiry"
          title="Are You Sure to Change the Expiry Hour?"
          ok-title="Save"
          header-bg-variant="warning"
          cancel-variant="outline-secondary"
          size="lg"
          @ok="SaveExpiryHour"
        >
          <b-form>
            <strong>Choose Expiry Hour for: {{ selectedFop }}</strong>
            <hr />
            <b-row>
              <b-col md="6">
                <b-form-group label="Hours" label-for="houres">
                  <b-form-input
                    id="hours-input"
                    v-model.number="houres"
                    type="number"
                    required
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-modal>

        <b-modal
          id="modal-assignpaymentoptions"
          title="Assign Payment Option"
          ok-title="submit"
          size="lg"
          cancel-variant="outline-secondary"
          @ok="submitAssignFops"
        >
          <b-form>
            <b-form-group label="Select Payment Options">
              <b-form-checkbox-group
                v-model="assignSelected"
                :options="assignOptions"
                switches
                stacked
              />
            </b-form-group>
            <!-- <h3>selected Merchant:{{ selectedMerchant }}</h3> -->
          </b-form>
        </b-modal>
      </b-row>
      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </b-card>
  </div>
</template>
<script>
import {
  BRow,
  BCol,
  BFormInput,
  BTable,
  BPagination,
  BAvatar,
  BBadge,
  BFormSelect,
  BForm,
  BLink,
  BCard,
  BOverlay,
  BDropdownItem,
  BDropdown,
  BButton,
  BFormGroup,
  BFormCheckboxGroup,
} from "bootstrap-vue";
import { required } from "@validations";
import axios from "@axios";

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BTable,
    BPagination,
    BAvatar,
    BBadge,
    BFormSelect,
    BLink,
    BCard,
    BOverlay,
    BDropdownItem,
    BDropdown,
    BButton,
    BFormGroup,
    BFormCheckboxGroup,
    BForm,
  },
  data() {
    return {
      required,
      boolValue: null,
      selectedStatus: 0,
      statusOptions: [
        { value: 0, text: "All" },
        { value: 1, text: "Inactive Payment" },
        { value: 2, text: "Active Payment" },
        { value: 3, text: "Active Refund" },
        { value: 4, text: "Inactive Refund" },
      ],
      isLoading: false,
      props: ["paymentOptions"],
      fields: [
        "Logo",
        "name",
        "code",
        "provider",
        "type",
        "country",
        "currency",
        "expiryHour",
        "instruction",
        { key: "statusDescription", label: "Payment Status" },
        { key: "refundActiveStatusDescription", label: "Refund Status" },
        "Actions",
      ],
      paymentOptions: [],
      filter: "",
      perPage: 10,
      currentPage: 1,
      name: "",
      code: "",
      country: "",
      provider: "1",
      type: "2",
      instruction: "",
      typeSelected: [],
      providerSelected: ["1"],
      typeOptions: [
        { value: "2", text: "Card" },
        { value: "3", text: "Mobile" },
        { value: "4", text: "Bank" },
      ],
      providerOptions: [
        { value: "1", text: "Amole" },
        { value: "2", text: "CBE" },
        { value: "3", text: "PSS" },
        { value: "4", text: "United" },
        { value: "5", text: "Abssinia" },
      ],
      houres: null,
      selectedFop: null,
      selectedFopId: null,
      assignSelected: [],
      assignOptions: [],
      selectedMerchantId: JSON.parse(localStorage.getItem("defaultMerchantId")),
      userRole: localStorage.getItem("userRole"),
    };
  },
  computed: {
    rows() {
      return this.paymentOptions.length;
    },
  },
  created() {
    this.fetchData();
  },
  mounted() {
    // this.fetchData().catch(error => {
    //   console.error(error)
    // })
  },
  methods: {
    EnablePaymentOption(id, name) {
      this.$bvModal
        .msgBoxConfirm(`Are you sure to Enable Payment for ${name}`, {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "primary",
          headerBgVariant: "success",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.isLoading = true;
            axios
              .put(
                "/PaymentOptions/api/V1.0/PaymentOptions/ActivateDeactivatePaymentOption",
                {
                  statusAction: 1,
                  id,
                },
              )
              .then((res) => {
                this.isLoading = false;
                // eslint-disable-next-line no-alert
                this.$bvModal.msgBoxOk(`${res.message}`, {
                  title: "Success",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "success",
                  headerClass: "p-2 border-bottom-0",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                });
                this.fetchData();
              })
              .catch(() => {
                this.isLoading = false;
              });
          }
        });
    },
    DisablePaymentOption(id, name) {
      this.$bvModal
        .msgBoxConfirm(`Are you sure to Disable Payment for ${name}`, {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          headerBgVariant: "warning",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          this.boolValue = value;
          if (value) {
            this.isLoading = true;
            axios
              .put(
                "/PaymentOptions/api/V1.0/PaymentOptions/ActivateDeactivatePaymentOption",
                {
                  statusAction: 2,
                  id,
                },
              )
              .then((res) => {
                this.isLoading = false;
                this.$bvModal.msgBoxOk(`${res.message}`, {
                  title: "Success",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "success",
                  headerClass: "p-2 border-bottom-0",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                });
                this.fetchData();
              })
              .catch(() => {
                this.isLoading = false;
              });
          }
        });
    },
    EnableRefundPaymentOption(id, name) {
      this.$bvModal
        .msgBoxConfirm(`Are you sure to Enable refund for ${name}`, {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "primary",
          headerBgVariant: "success",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.isLoading = true;
            axios
              .put(
                "/PaymentOptions/api/V1.0/PaymentOptions/ActivateDeactivatePaymentOptionForRefund",
                {
                  statusAction: 1,
                  id,
                },
              )
              .then((res) => {
                this.isLoading = false;
                // eslint-disable-next-line no-alert
                this.$bvModal.msgBoxOk(`${res.message}`, {
                  title: "Success",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "success",
                  headerClass: "p-2 border-bottom-0",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                });
                this.fetchData();
              })
              .catch(() => {
                this.isLoading = false;
              });
          }
        });
    },
    DisableRefundPaymentOption(id, name) {
      this.$bvModal
        .msgBoxConfirm(`Are you sure to Disable refund for ${name}`, {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          headerBgVariant: "warning",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          this.boolValue = value;
          if (value) {
            this.isLoading = true;
            axios
              .put(
                "/PaymentOptions/api/V1.0/PaymentOptions/ActivateDeactivatePaymentOptionForRefund",
                {
                  statusAction: 2,
                  id,
                },
              )
              .then((res) => {
                this.isLoading = false;
                this.$bvModal.msgBoxOk(`${res.message}`, {
                  title: "Success",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "success",
                  headerClass: "p-2 border-bottom-0",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                });
                this.fetchData();
              })
              .catch(() => {
                this.isLoading = false;
              });
          }
        });
    },
    handleOk() {
      this.$bvModal.msgBoxConfirm(`Name:${this.name}`).then((value) => {
        this.boolValue = value;
      });
    },
    redirectto(id) {
      this.boolValue = id;
      this.$router.push("dashboard-ecommerce");
    },
    manageInstructions(id, name) {
      this.$router.push({ name: "instructions-manage", query: { id, name } });
    },
    validationForm() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          // eslint-disable-next-line
          alert(
            "form submitted! " +
              this.name +
              ":" +
              this.code +
              ":" +
              this.instruction +
              ":" +
              this.country +
              ":" +
              this.type +
              ":" +
              this.provider,
          );
          this.$refs.modal.hide();
        }
      });
    },
    fetchData() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "MerchantFOP-View");
      axios
        .get(
          "/PaymentOptions/api/V1.0/PaymentOptions/ViewMerchantPaymentOptions",
        )
        .then((res) => {
          this.paymentOptions = res.paymentOptions;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    filterPaymentOptions() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "MerchantFOP-View");
      this.paymentOptions = [];
      let relativeUrl = "";
      if (this.selectedStatus === 0) {
        relativeUrl =
          "/PaymentOptions/api/V1.0/PaymentOptions/FilterMerchantPaymentOptions?filterPaymentOption=0";
      } else if (this.selectedStatus === 1) {
        relativeUrl =
          "/PaymentOptions/api/V1.0/PaymentOptions/FilterMerchantPaymentOptions?filterPaymentOption=1";
      } else if (this.selectedStatus === 2) {
        relativeUrl =
          "/PaymentOptions/api/V1.0/PaymentOptions/FilterMerchantPaymentOptions?filterPaymentOption=2";
      } else if (this.selectedStatus === 3) {
        relativeUrl =
          "/PaymentOptions/api/V1.0/PaymentOptions/FilterMerchantPaymentOptions?filterPaymentOption=3";
      } else if (this.selectedStatus === 4) {
        relativeUrl =
          "/PaymentOptions/api/V1.0/PaymentOptions/FilterMerchantPaymentOptions?filterPaymentOption=4";
      }

      axios
        .get(relativeUrl)
        .then((res) => {
          console.log(res);
          this.paymentOptions = res.paymentOptions;
          this.isLoading = false;
        })
        .catch((res) => {
          console.log(res);
          this.$bvModal.msgBoxOk(`${res.data.message}`, {
            title: "Success",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
          });
          this.isLoading = false;
        });
    },
    ChangePaymentOptionExpiry(id, name, expiryhour) {
      this.selectedFop = name;
      this.selectedFopId = id;
      this.houres = expiryhour;
      this.$bvModal.show("modal-change-expiry");
    },
    assignMerchant() {
      this.assignSelected = [];
      this.assignOptions = [];
      this.returnedAssignedFops = [];
      this.selectedAssignedIds = [];
      this.isLoading = true;
      this.$store.dispatch(
        "config/getActionPrivilege",
        "MerchantFOP-AssignUnAssign",
      );
      axios
        .get(
          `/PaymentOptions/api/V1.0/PaymentOptions/ViewAssignedUnAssignedPaymentOptions?merchantId=${this.selectedMerchantId}`,
        )
        .then((res) => {
          res.paymentOptions.forEach((item) => {
            this.assignOptions.push({
              value: item.id,
              text: item.name,
            });
            this.returnedAssignedFops.push({
              paymentOptionId: item.id,
              merchantFopId: item.merchantPaymentOptionId,
              assigned: item.isAssigned,
            });
            if (item.isAssigned) {
              this.assignSelected.push(item.id);
            }
          });
          console.log(this.returnedAssignedFops);
          this.$bvModal.show("modal-assignpaymentoptions");
          this.isLoading = false;
        })
        .catch((res) => {
          console.log(res);
          this.$bvModal.msgBoxOk(`${res.data.message}`, {
            title: "Success",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
          });
          this.isLoading = false;
        });
    },
    submitAssignFops() {
      this.returnedAssignedFops.forEach((item) => {
        if (this.assignSelected.includes(item.paymentOptionId)) {
          this.selectedAssignedIds.push({
            paymentOptionId: item.paymentOptionId,
            merchantPaymentOptionId: item.merchantFopId,
          });
        }
      });
      console.log(this.selectedAssignedIds);
      this.isLoading = true;
      axios
        .post(
          "/PaymentOptions/api/V1.0/PaymentOptions/AssignUnAssignPaymentOptionsToMerchant",
          {
            paymentOptions: this.selectedAssignedIds,
          },
        )
        .then((res) => {
          this.isLoading = false;
          this.$bvModal.msgBoxOk(`${res.message}`, {
            title: "Success",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
          });
          this.fetchData();
        })
        .catch((res) => {
          this.isLoading = false;
          this.$bvModal.msgBoxOk(res.data.message, {
            title: "Error",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
          });
        });
    },
    SaveExpiryHour() {
      this.isLoading = true;
      axios
        .put(
          "/PaymentOptions/api/V1.0/PaymentOptions/ChangePaymentOptionsExpiry",
          {
            paymentOptionId: this.selectedFopId,
            expiryHour: this.houres,
          },
        )
        .then((res) => {
          this.isLoading = false;
          this.fetchData();
          this.$bvModal.msgBoxOk(`${res.message}`, {
            title: "Success",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
          });
        })
        .catch((res) => {
          this.isLoading = false;
          this.$bvModal.msgBoxOk(res.data.message, {
            title: "Error",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
          });
        });
    },
    UnAssignPaymentOption(id, name) {
      this.$bvModal
        .msgBoxConfirm(` to UnAssign: ${name}`, {
          title: "Are You Sure",
          size: "sm",
          buttonSize: "sm",
          okVariant: "warning",
          headerBgVariant: "warning",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.isLoading = true;
            axios
              .put(
                "/PaymentOptions/api/V1.0/PaymentOptions/UnAssignPaymentOption",
                {
                  paymentOptionId: id,
                },
              )
              .then((res) => {
                this.isLoading = false;
                this.fetchData();
                this.$bvModal.msgBoxOk(`${res.message}`, {
                  title: "Success",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "success",
                  headerClass: "p-2 border-bottom-0",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                });
              })
              .catch((res) => {
                this.isLoading = false;
                this.$bvModal.msgBoxOk(res.data.message, {
                  title: "Error",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "success",
                  headerClass: "p-2 border-bottom-0",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                });
              });
          }
        });
    },
  },
};
</script>
